import { Header } from "../components/Header"
import { PiUserCircleThin } from "react-icons/pi";
import { BsClock } from "react-icons/bs";
import { useEffect, useState } from "react";
import { api } from "../api/api";
import { Message } from "../@types/Message";


export const Messages = () => {

    const [messages, setMessages] = useState<Message[]>([]);
    const [error, setError] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);

    const getMessages = async () => {
        try {
            setIsLoading(true);
            const recados: Message[] = (await api.get('/messages')).data;
            setMessages(recados);
            setIsLoading(false);
        } catch (err) {
            setError('Erro ao buscar mensagens. Tentando novamente...');
            setIsLoading(false);
        }
    };

    useEffect(() => {
        let intervalId: NodeJS.Timeout;

        const checkMessages = () => {
            if (messages.length === 0) {
                getMessages();
            }
        };

        intervalId = setInterval(checkMessages, 5000);

        return () => clearInterval(intervalId);
    }, [messages]);

    return (
        <>
            <Header />

            <div className="flex md:flex-row flex-col">
                <div className="md:w-3/12 w-100">
                    <FormMessage />
                </div>

                <div className="flex flex-wrap md:w-9/12">
                    {isLoading && <p className="poppins-normal pt-3 ml-3 text-2xl">Carregando...</p>}
                    {messages.map((msg, index) => 
                    (
                        msg.show && <MessageBox key={index} author={msg.author}  message={msg.message} created_at={msg.created_at}/>
                    ))}
                </div>
            </div>
        </>
    )
}

const FormMessage = () => {

    const [form, setForm] = useState({author:'', message:''});
    const [submitLoading, setSubmitLoading] = useState(false);

    const postMessage = async () => {
        setSubmitLoading(true)
        await api.post('/message', {
            author: form.author,
            message: form.message
        });
        setForm({author: '', message: ''});
    }

    return (
        <div className="py-4 w-5/6 mx-auto drop-shadow-md">
            <h3 className="poppins-regular text-xl text-center">Deixe seu recado</h3>
            <form className="flex flex-col flex p-2 gap-3">
                <input value={form.author} onChange={({ target }) => setForm({...form, author: target.value})} type="text" className="border px-2 h-12 rounded-lg" name="name" id="name" />
                <textarea value={form.message} onChange={({ target }) => setForm({...form, message: target.value})} name="message" id="message" className="w-full h-24 border rounded-lg resize-none p-2"></textarea>
                <input onClick={(event) => {
                    event.preventDefault();
                    postMessage()    
                }}  className="bg-emerald-950 text-white px-4 py-2 poppins-regular rounded-md cursor-pointer" type="submit" value={"Enviar"} />
            </form>
            {submitLoading && 
            <>
                <p>Obrigado pela consideração</p>
                <p>A mensagem será avaliada para evitar SPAM</p>
            </>
            }
        </div>
    )
}   

const MessageBox = ({author, created_at, message}: Message) => {
    function diasPassados(dataInicial: string) {
        const dataInicialObj: Date = new Date(dataInicial);
        const dataAtualObj: Date = new Date();
      
        // Aqui garantimos que as operações são entre tipos numéricos
        const diferencaEmMilissegundos: number = dataAtualObj.getTime() - dataInicialObj.getTime();
        const diferencaEmDias: number = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24));
        
        return diferencaEmDias;
        }
    return (<div className="md:basis-1/3 p-4">
        <div className="p-4 border shadow-md rounded-md">
            <div className="flex poppins-regular items-center gap-2">
                <PiUserCircleThin className="text-5xl text-gray-400"/>
                <div>
                    <h3 className="text-xl">{author}</h3>
                    <span className="text-md poppins-light flex items-center gap-1"><BsClock /> <p>há {diasPassados(created_at)} dias</p></span>
                </div>
            </div>
            <p>{message}</p>
        </div>
    </div>)
}